<template>
  <div>
    <el-form class="selectlesson">
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          @change="getFile"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          clearable
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          clearable
          v-model="model.clID"
          @change="getFile"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- 显示表格 -->
    <template v-show="fileData">
      <el-table :data="fileData" border style="width: 100%">
        <el-table-column
          prop="createAt"
          label="创建时间"
          width="85"
          :formatter="formatDate"
        >
        </el-table-column>
        <el-table-column prop="major" label="所属网校" width="90">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.major" :key="tag.index">
              <el-tag v-show="tag.maName" style="margin: 3px">{{
                tag.maName
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="channel" label="一级分类" width="115">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.channel" :key="tag.index">
              <el-tag v-show="tag.chName" style="margin: 3px">{{
                tag.chName
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="course" label="二级分类" width="150">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.course" :key="tag.index">
              <el-tag v-show="tag.coName" style="margin: 3px">{{
                tag.coName
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="class" label="三级分类" width="180">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.class" :key="tag.index"
              ><el-tag v-show="tag.clName" style="margin: 3px">{{
                tag.clName
              }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="files" label="文件资料">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.files" :key="tag.index"
              ><el-tooltip
                content="点击下载"
                effect="light"
                placement="right-start"
                ><el-button
                  plain
                  type="primary"
                  size="small"
                  @click="downFile(tag.response.file.filePath)"
                  style="margin: 3px"
                  >{{ tag.name }}</el-button
                ></el-tooltip
              ></span
            >
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="95">
          <template slot-scope="scope">
            <el-button
              style="margin: 3px 3px 3px 3px"
              @click="$router.push(`/files/edit/${scope.row._id}`)"
              type="primary"
              icon="el-icon-edit"
              size="small"
              plain
              >编辑</el-button
            >
            <el-button
              style="margin: 15px 3px 3px 3px"
              @click="fileDelete(scope.row._id)"
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <el-skeleton :rows="6" :loading="loading" animated />
    <!--  file分类分页 -->
    <div class="file-page">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="filepre"
        @next-click="filenext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="fileLength"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { timerfilter } from "../util/timerfilter";

export default {
  data() {
    return {
      loading: true,
      major: [],
      channel: [],
      course: [],
      shclass: [],
      fileData: [],
      lesson: [],
      model: {},
      fileLength: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },

  methods: {
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }

      //this.getFile(item);
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
        this.getFile(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
        this.getFile(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getFile() {
      try {
        const getFile = await this.$http.get("/files/getfile", {
          params: {
            maID: this.model.maID,
            chID: this.model.chID,
            coID: this.model.coID,
            clID: this.model.clID,
            page: this.currentPage,
            size: this.pageSize,
          },
        });
        //console.log(getFile.data);
        this.fileData = getFile.data[0].result;
        this.fileLength = getFile.data[0].resultLength[0].totalCount;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    //下载文件
    async downFile(path) {
      try {
        await window.open(path);
      } catch (error) {
        console.log(error);
      }
      //console.log(path);
    },
    //删除文件
    fileDelete(id) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
        center: true,
      })
        .then(async () => {
          let res = await this.$http.delete("/files/delfile?_id=" + `${id}`);

          if (res.status === 203) {
            this.$message({ type: "success", message: res.data.msg });
            this.getFile();
          } else {
            this.$message(res.message);
          }
        })
        .catch((res) => {
          if (res === "cancel") {
            this.$message({
              type: "info",
              message: "取消删除",
            });
          } else {
            //console.log(res);
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
    //file分类分页
    async filepre() {
      try {
        this.currentPage--;
      } catch (error) {
        console.log(error);
      }

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async filenext() {
      try {
        this.currentPage++;
      } catch (error) {
        console.log(error);
      }

      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
    async changeSize(size) {
      try {
        this.pageSize = size;
      } catch (error) {
        console.log(error);
      }
    },
    async currentChange(currentPage) {
      try {
        this.currentPage = currentPage;
        this.getFile(this.currentPage);
      } catch (error) {
        console.log(error);
      }

      //console.log(this.currentPage);
    },
    //日期格式化插件
    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
  },

  created() {
    this.getMajor();
    this.getChannel();
    this.getFile();
  },
};
</script>

<style></style>
